import { gsap } from 'gsap'

export class CarSlider {
    constructor() {
        this._section = document.querySelector('.s-car-slider')
        if (!this._section) return

        this._init()
    }

    _init() {
        const titlesJson = this._section.getAttribute('data-titles')
        const titles = titlesJson ? JSON.parse(titlesJson) : []

        const currentEl = this._section.querySelector('.s-car-slider__title--current')
        const nextEl = this._section.querySelector('.s-car-slider__title--next')

        const swiperEl = this._section.querySelector('.slider--cars')

        const runTransition = (newTitle) => {
            nextEl.textContent = newTitle
            gsap.set(nextEl, { y: '100%', opacity: 1 })

            const tl = gsap.timeline({
                onComplete: () => {
                    currentEl.textContent = newTitle
                    gsap.set(currentEl, { y: 0, opacity: 1 })
                    gsap.set(nextEl, { y: '100%', opacity: 1 })
                    nextEl.textContent = ''
                },
            })

            tl.to(currentEl, {
                y: '100%',
                opacity: 0,
                duration: 0.28,
                ease: 'power2.in',
            }).fromTo(
                nextEl,
                { y: '120%' },
                {
                    y: '0%',
                    duration: 0.28,
                    ease: 'power2.out',
                },
                '>'
            )
        }

        const onSlideChange = () => {
            const swiper = swiperEl.swiper
            if (!swiper) return
            const index = swiper.realIndex ?? swiper.activeIndex
            const newTitle = titles[index] ?? ''
            runTransition(newTitle)
        }

        swiperEl.swiper.on('slideChangeTransitionStart', onSlideChange)

    }
}
